import { Block, Button, Navbar, Page } from "framework7-react";

import { NavLeftBack } from "@/components/NavLeftBack";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavTitle } from "@/components/NavTitle";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { usePageReady } from "@/hooks/usePageReady";

export const DebugSentryPage = createPage("DebugSentryPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { getPageProps } = usePageReady(pageName);

  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar>
        <NavLeftBack />
        <NavTitle>Sentry Debug</NavTitle>
        <NavRightEmpty />
      </Navbar>
      <Block
        inset
        strong
      >
        <Button
          fill
          onClick={() => {
            throw new Error("Sentry Test Error");
          }}
        >
          Break the world
        </Button>
      </Block>
    </Page>
  );
}
